import React from "react";

export default function EditInitPopup({ closeToast, onBackToInventory }) {
  const handleClose = () => {
    closeToast(); // Close the toast when "OK" is clicked
    // Call the callback function to navigate
    if (onBackToInventory) {
      onBackToInventory();
    }
  };

  return (
    <div>
      <div className="">
        <div id="">
          <div id="">
            <p className="popUpText">
              Your Document(s) have been Uploaded!
            </p>
            <button className="alert_button" onClick={handleClose}>
              OK
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
